module.exports = __webpack_public_path__ + "img/gu.d0da25e.svg";